module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_500-7083e67a4b00235fee5d1bb9213ef33c.png";